export default {
  'box': {
    'maximize': 'Maximiser',
    'minimize': 'Minimiser'
  },
}
